import { useEffect, useState } from "react";

function useAppSizeControl(app: HTMLElement) {
  const [isLogoHidden, setIsLogoHidden] = useState(true);

  useEffect(() => {
    function handleScroll() {
      if (app === null) {
        app = document.querySelector(
          "#volvoTrucksConfiguratorApp"
        ) as HTMLElement;
      }
      const appTop = app?.getBoundingClientRect().top ?? 0;
      if (window.scrollY >= 175) {
        app.style.position = "fixed";
        app.style.top = "0";
        app.style.left = "0";
        app.style.width = "100vw";
        app.style.height = "100dvh";
        app.style.bottom = "0";
        app.style.right = "0";
        app.style.zIndex = "2147483644";
        app.style.overflowY = "auto";

        const volvoHeader = document.querySelector(".header") as HTMLElement;
        document.querySelectorAll(".top-banner").forEach((selector) => {
          const topBanner = selector as HTMLElement;
          if (topBanner) {
            topBanner.style.zIndex = "2147483647";
          }
        });
        const volvoCookieConsent = document.querySelector(
          "#onetrust-banner-sdk"
        ) as HTMLElement;
        const volvoCookieConsentDarkfade = document.querySelector(
          ".onetrust-pc-dark-filter"
        ) as HTMLElement;

        if (volvoHeader) {
          volvoHeader.style.display = "none";
        }
        if (volvoCookieConsent) {
          volvoCookieConsent.style.zIndex = "2147483647";
        }
        if (volvoCookieConsentDarkfade) {
          volvoCookieConsentDarkfade.style.zIndex = "2147483646";
        }

        setIsLogoHidden(false);
        return;
      } else if (app && appTop <= 10) {
        app.style.position = "fixed";
        app.style.top = "0";
        app.style.left = "0";
        app.style.width = "100vw";
        app.style.height = "100dvh";
        app.style.bottom = "0";
        app.style.right = "0";
        app.style.zIndex = "2147483645";
        app.style.overflowY = "auto";

        const volvoHeader = document.querySelector(".header") as HTMLElement;
        document.querySelectorAll(".top-banner").forEach((selector) => {
          const topBanner = selector as HTMLElement;
          if (topBanner) {
            topBanner.style.zIndex = "2147483647";
          }
        });
        const volvoCookieConsent = document.querySelector(
          "#onetrust-banner-sdk"
        ) as HTMLElement;
        const volvoCookieConsentDarkfade = document.querySelector(
          ".onetrust-pc-dark-filter"
        ) as HTMLElement;

        if (volvoHeader) {
          volvoHeader.style.display = "none";
        }
        if (volvoCookieConsent) {
          volvoCookieConsent.style.zIndex = "2147483647";
        }
        if (volvoCookieConsentDarkfade) {
          volvoCookieConsentDarkfade.style.zIndex = "2147483646";
        }
        setIsLogoHidden(false);
        return;
      }

      if (app) {
        if (window.scrollY < 10) {
          app.style.position = "";
          app.style.top = "";
          app.style.height = "";
          app.style.width = "";
          setIsLogoHidden(true);
        }
      }
    }

    handleScroll();
    document.addEventListener("scroll", handleScroll);
    return () => {
      document.removeEventListener("scroll", handleScroll);
    };
  }, [app]);

  return [isLogoHidden, setIsLogoHidden] as const;
}

export default useAppSizeControl;
